import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Download } from '@tds/core-interactive-icon';
import Heading from '@tds/core-heading';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';
import {
  isOrderFulfillmentTeam,
  isAdmin,
  isSalesRep
} from '../../../../../../utils/request';
import Attachements from './attachements';

const OrderAttachments = ({ orderData }) => {
  const localizedString = useLocalizedStringsContext();
  const { iotAccountType, pdfLinks } = orderData;
  const {
    ORDERS: { contractUnSigned, contractSignedPdf, attachments },
    contentfulValues: { valueCorporate }
  } = localizedString;

  if (
    (isSalesRep && !_.get(orderData, `pdfLinks.contractSignedPdf`, false)) ||
    iotAccountType === valueCorporate
  )
    return null;

  const getLink = (name, label) =>
    _.get(pdfLinks, name, '') && (
      <li
        className="list-group-item"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div>{label}</div>
        <div>
          <Download
            onClick={() =>
              window.open(
                `${_.get(pdfLinks, name, '')}?download=true`,
                '_blank'
              )
            }
            a11yText="Download"
          />
        </div>
      </li>
    );

  return (
    <>
      <>
        <Heading level="h3">{attachments}</Heading>
        {(getLink('contractUnSigned', contractUnSigned) ||
          contractUnSigned) && (
          <div className="card" style={{ marginTop: '1rem' }}>
            <div className="card-header">
              <Heading level="h4">Contract PDF</Heading>
            </div>
            <ul className="list-group list-group-flush">
              {(isOrderFulfillmentTeam || isAdmin) &&
                getLink('contractUnSigned', contractUnSigned)}
              {getLink('contractSignedPdf', contractSignedPdf)}
            </ul>
          </div>
        )}
        <Attachements
          isUploadAvailable={isOrderFulfillmentTeam}
          orderData={orderData}
        />
      </>
    </>
  );
};

OrderAttachments.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired
};

export default OrderAttachments;
